<template>
  <div class="animated fadeIn">     
    <b-row>
      <b-col md="12">
<!--          <b-breadcrumb :items="breadcrumbs"/>       
 -->        <b-card>
          <div slot="header">
            <strong> Admin user</strong>
            <div class="card-header-actions" >                
              <button class="btn btn-sm btn-primary mr-4 btn-pill" v-on:click="useradd()"  type="button">Add New</button>
               <button class="btn btn-sm btn-primary ml-4" v-on:click="refresh()" type="button"><i class="fa fa-refresh"></i></button>
            </div>
          </div>

         
          <div id="adduser"  style="padding: .75rem 1.25rem;border: 1px solid rgba(0,0,0,.125);display:none;" class="mb-1">
              <b-form @submit.prevent="validateForm('form-1')" data-vv-scope="form-1">
               <input type="hidden" name="chkEditVal" id="chkEditVal" value="0">
                <b-row>
                  <b-col sm="3">
                    <b-form-group>
                      <label for="pickuplocationmasterid">Hub</label>
                      
                      {{/* v-if="currenthubidselct!=hub.pickuplocationmasterid" */}}
                      <b-form-select v-model="customer.pickuplocationmasterid" name="pickuplocationmasterid" v-validate="'required'" :class="{'input': true, 'text-danger': errors.has('form-1.pickuplocationmasterid') }">
                        <option :value="selected">--Select--</option>
                        <option v-for="hub in hublist"  v-bind:value="hub.pickuplocationmasterid">{{hub.pickuplocationname}}</option>
                    </b-form-select> 
                    </b-form-group>
                  </b-col>
                  
                  <b-col sm="3">
                    <b-form-group>
                      <label for="sysemailid">Email id</label>
                      <b-input-group class="mb-3">                     
                        <b-form-input class="input" type="text" name="sysemailid" v-model="customer.sysemailid" v-validate="'required|email'" :class="{'input': true, 'text-danger': errors.has('form-1.sysemailid') }" placeholder="Enter Email id">
                        </b-form-input>
                      </b-input-group>
                     
                      </b-form-group>
                  </b-col>
                  <b-col sm="3">
                    <b-form-group>
                      <label for="first name">First Name</label>
                      <b-form-input type="text" name="first name" v-model="customer.userfirstname" v-validate="'required|alpha|min:3|max:30'" :class="{'input': true, 'text-danger': errors.has('form-1.first name') }" placeholder="Enter First Name">                       
                       </b-form-input>
                      <b-input-group class="mb-3">
                      <span class="icon has-text-warning">
                        <i class="fa fa-warning" v-show="errors.has('first name')" ></i>
                      </span>
                      <span style="width:240px" v-show="errors.has('form-1.first name')" class="help text-danger">{{ errors.first('form-1.first name') }}</span>
                      </b-input-group>
                      </b-form-group>
                  </b-col>

                  <b-col sm="3">
                    <b-form-group>
                      <label for="last name">Last Name</label>
                      <b-input-group class="mb-3">                     
                        <b-form-input class="input" type="text" name="last name" v-model="customer.userlastname" v-validate="'required|alpha|min:3|max:30'" :class="{'input': true, 'text-danger': errors.has('form-1.last name') }" placeholder="Enter Last Name">
                        </b-form-input>
                      </b-input-group>
                      <b-input-group class="mb-3">
                      <span class="icon has-text-warning">
                        <i class="fa fa-warning" v-show="errors.has('last name')" ></i>
                      </span>
                         <span style="width:240px" v-show="errors.has('form-1.last name')" class="help text-danger">{{ errors.first('form-1.last name') }}</span>
                      </b-input-group>
                      </b-form-group>
                  </b-col>
                  
                </b-row>
                <b-row>
                  <b-col sm="3">
                    <b-form-group>
                      <label for="usermobilenumber">Mobile Number</label>
                      <b-input-group class="mb-3">
                          <b-form-input class="input" type="text" id="usermobilenumber" name="mobile number" maxlength="10" v-model="customer.usermobilenumber" v-validate="'required|digits:10'" :class="{'input': true, 'text-danger': errors.has('form-1.mobile number') }" placeholder="Enter Mobile Number" >
                          </b-form-input>  
                      </b-input-group>
                      <b-input-group class="mb-3">
                      <span class="icon has-text-warning">
                        <i class="fa fa-warning" v-show="errors.has('mobile number')" ></i>
                      </span>
                      <code v-show="errors.has('form-1.mobile number')" id="addmblnbrmsg" class="help text-danger">{{ errors.first('form-1.mobile number') }}
                      </code>
                      </b-input-group>
                      </b-form-group>
                  </b-col>

                  <b-col sm="3">
                    <b-form-group>
                      <label for="Password">Password</label>
                      <b-input-group class="mb-3">
                         <b-form-input class="input" type="password" name="syspassword" minlength="6" maxlength="14" v-model="customer.syspassword" v-validate="'required|'" :class="{'input': true, 'text-danger': errors.has('form-1.syspassword') }" placeholder="Enter Password">
                         </b-form-input>
                      </b-input-group>
                      <b-input-group class="mb-3">
                      <span class="icon has-text-warning">
                        <i class="fa fa-warning" v-show="errors.has('syspassword')" ></i>
                      </span>
                      <code v-show="errors.has('form-1.syspassword')" id="passwordtxt" class="help text-danger">{{ errors.first('form-1.syspassword') }}
                      </code>                      
                      </b-input-group>
                      </b-form-group>
                  </b-col>
                 
                  <b-col sm="3">
                      <b-form-group>
                        <label for="pincode">Status</label>
                        <b-input-group class="mb-3">
                          <b-form-select v-model="customer.isactive" name="status" v-validate="'required|'" :class="{'input': true, 'is-invalid': errors.has('form-1.status') }">
                          <option value="">--Select--</option>
                          <option value="1">Active</option>
                          <option value="0">InActive</option>
                        </b-form-select>
                        </b-input-group>
                        <b-input-group class="mb-3">
                        <span class="icon has-text-warning">
                          <i class="fa fa-warning" v-show="errors.has('status')" ></i>
                        </span>
                        <code v-show="errors.has('form-1.status')" id="statustxt" class="help text-danger">{{ errors.first('form-1.status') }}
                        </code>
                        </b-input-group>
                        </b-form-group>
                  </b-col>
                </b-row>
                <footer class="column has-text-right">
                <b-button variant="primary" size="md" type="submit">Save</b-button>
                </footer>
              </b-form>
            </div>
            

     
          <b-table show-empty stacked="md"  :items="items" :busy="isBusy"    :current-page="currentPage"  :fields="fields" :per-page="perPage"  :filter="filter"   :sort-by.sync="sortBy"  :sort-desc.sync="sortDesc"   :sort-direction="sortDirection"      :bordered="bordered" > 

            <div slot="table-busy" class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Loading...</strong>
            </div>  
             <template slot="actions" slot-scope="row">
             <b-button size="sm" @click="info(row.item, row.index, $event.target)" class="mr-1">
                     Delivery Boy
              </b-button>
            </template>
            <template slot="usertype" slot-scope="row">
             {{row.item.user_type == 0 ? 'Normal ' : 'Privilage'}}
            </template>
           <template slot="isactive" slot-scope="row">
             <span data-toggle="tooltip" title="InActive" v-if="row.value.isactive ==='0'" style="color:red"> <i class="badge badge-success">In Active</i></span>
            <span data-toggle="tooltip" title="Active" v-else style="color:green"><i class="badge badge-success">Active</i></span>
            </template>
          </b-table>

          <b-col md="12" class="my-1 " v-if="this.totalRows > 10">
            <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                class="my-0"
              ></b-pagination>
          </b-col>    
        </b-card>
        <b-modal :id="infoModal.id" :title="infoModal.title" ok-only @hide="resetInfoModal">
      <pre>{{ infoModal.content }}</pre>
      </b-modal>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import CONSTANTS from '@/utils/constants'
import Utils from '@/utils'
import Vue from 'vue'
export default {
  name: 'adminuser', 
  data: function() {
    return {
      name: 'adminuser',
      isBusy: false,
      breadcrumbs: [{
        text: 'Dashboard',
        href: '/dashboard'
      },{
        text: 'Admin user',
        active: true
      }],
      data: [],
      clientdata: [],
      add: true,
      //selected:'',           
      customer: {},
      items:[],
      hublist: [],
     fields: [
          { key: 'pickuplocationmasterid', label: 'Hub Name', sortable: true, sortDirection: 'desc' },
          { key: 'sysemailid', label: 'Email ID', sortable: true},
          // { key: 'syspassword', label: 'Password', sortable: true},
          { key: 'userfirstname', label: 'First Name', sortable: true},          
          { key: 'userlastname', label: 'Last Name', sortable: true },    
          { key: 'usermobilenumber', label: 'mobilenumber', sortable: true },
          { key: 'usertype', label: 'User Type', sortable: true },
          { key: 'isactive', label: ' status' },
          // { key: 'actions', label: 'Actions' },
        
       ], 
        bordered: true,
        totalRows: 0,
        currentPage: 1,
        perPage:  10,
        pageOptions: [5, 10, 15],
        sortBy: null,
        sortDesc: false,
        sortDirection: 'asc',
        filter: null,
        currenthubidselct:'',
        infoModal: {
          id: 'info-modal',
          title: '',
          content: ''
        }
    }
  },
  created: function() {
    this.gethublist();
    this.displaydata();
    var userdata = localStorage.getItem('userData')
    var userInfo = JSON.parse(userdata)
    this.currenthubidselct=userInfo.pickuplocationmasterid.toString();
  },
  
  methods: {
    info(item, index, button) {
        this.infoModal.title = `Row index: ${index}`
        this.infoModal.content = JSON.stringify(item, null, 2)
        this.$root.$emit('bv::show::modal', this.infoModal.id, button)
      },
      resetInfoModal() {
        this.infoModal.title = ''
        this.infoModal.content = ''
      },
    gethublist: function(){
      this.$http
        .post(`${CONSTANTS.API_URL}/ConsignmentMaster/gethublist`)
        .then(result => {
          if(result.body.returnmsg=='Successful'){
          this.hublist = result.body.returnvalue;
          }
          // console.log('this.gethublist',this.hublist);
        })
        .catch(ex => {
          alert(ex);
        });
    },   
    validateForm(scope) {
       this.$validator.validateAll(scope).then(result => {
        if (result) {          
          this.addAdminInfo();
        }
      });
    },
    clear1: function() {},
    useradd: function() {
      //this.customer = {};
      this.subtitle='Add Users';
      this.errors.clear("form-1");
   
      // var allocatepin = document.getElementById('allocatepin')
      // allocatepin.style.display = 'none'
      var adduser = document.getElementById("adduser");
      adduser.style.display = "block";
    
    },
    refresh:function() {
       this.subtitle='Users';
     
      // var allocatepin = document.getElementById('allocatepin')
      // allocatepin.style.display = 'none'
      var adduser = document.getElementById("adduser");
      adduser.style.display = "none";
      this.searchclear();
    },
    chkmobileVal() {
      var chkValidate = true;
     // var chknumb = /^[789]{1}\d{9}$/
      var chknumb = /^((\+[1-9]{1,4}[ \-]*)|(\([0-9]{2,3}\)[ \-]*)|([0-9]{2,4})[ \-]*)*?[0-9]{3,4}?[ \-]*[0-9]{3,4}?$/;
      var usermobilenumber = document.getElementById("usermobilenumber").value
      if (usermobilenumber.trim() === '0000000000' || usermobilenumber.trim().length < 10) {
        chkValidate = false
        return false
      } else if (usermobilenumber.trim() != "" && !(usermobilenumber.trim().match(chknumb))) {
        chkValidate = false
        return false
      }
      return chkValidate = chkValidate;
    },
    displaydata: function () {
    this.isBusy = true;
      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
     
      this.$http.get(`${CONSTANTS.API_URL}/DeliveryAgentMaster/getSystemuserList`)
        .then((result) => {
          if (result.body.returnmsg === 'Successful') {
            this.data = result.body.returnvalue
             this.items  = result.body.returnvalue;
            this.totalRows = result.body.returnvalue.length;
             this.isBusy = !this.isBusy;
          } else {
            alert('No records found')
          }
        })
        .catch((ex) => {
          console.log('error-----', ex)
        })
    },
    addAdminInfo: function() {
      var chkmobileVal = this.chkmobileVal();
      if (chkmobileVal) {

        var userdata = localStorage.getItem("userData");
        var userInfo = JSON.parse(userdata);
        if (this.customer.isactive === "1") {
          this.customer.isactive = "1";
        } else {
          this.customer.isactive = "0";
        }
       
        this.$validator.validateAll().then(result => {
         
          if (result) {
            this.$http
              .post(
                `${
                  CONSTANTS.API_URL
                }/DeliveryAgentMaster/SystemUserMasterAdd`,
                this.customer
              )
              .then(result => {
               
                if (result.body.returnmsg === "Successful") {
                  Utils.notify("Added successfully", "success");
                var adduser = document.getElementById("adduser");
               adduser.style.display = "none";
               this.clear();
                  //this.customer = {};
                  this.displaydata();


                  this.$router.push('/adminuser');
                } else {
                  if (result.body.returnmsg === "unsuccessful") {
                    Utils.notify(result.body[0].returnvalue, "error");
                  } else if (result.body[0].returnvalue === "0") {
                    Utils.notify(result.body[0].returnmsg, "error");
                  } else {
                    Utils.notify(result.body[0].returnmsg, "error");
                  }
                }
                 this.$router.push('/adminuser');
              })
              .catch(ex => {
                console.log("error", ex);
              });
          } else {
            Utils.notify("Correct them errors", "error");
          }
        });
      } else {
        Utils.notify("Please enter valid mobile number", "error");
      }
    },
     
    clear: function() {
      this.customer = {}
      this.errors.clear('form-1')    
    }    
    
  }
 
}
</script>

<style>
  /* IE fix */
  #card-chart-01, #card-chart-02 {
    width: 100% !important;
  }
</style>
